import { isPresent } from 'utils/isPresent';
import React, { PureComponent } from 'react';
import ui from 'redux-ui';
import { connect } from 'react-redux';
import AddressFormSection from '../../Common/Inputs/FormControls/AddressFormSection.jsx';
import FormTextField from '../../Common/Form/FormTextField.js.jsx';
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import IconButton from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/IconButton';
import CancelIcon from 'housecall-ui/dist/IconsAndImages/Icons/Cancel';
import { getFormValues } from 'redux-form';
import { CUSTOMER_INFO_FORM, onRemoveAddress } from './Redux/Actions';
import HCMap from '../../HCMap/HCMap.js.jsx';
import AddressMap from './AddressMap';

const styles = (theme) => ({
  mapPosition: {
    [theme.breakpoints.down('xs')]: {
      marginTop: 32,
    },
    [theme.breakpoints.up('xs')]: {},
    [theme.breakpoints.up('md')]: {
      position: 'relative',
      left: 74,
      paddingLeft: 18,
    },
  },
  deleteRowStyle: {
    backgroundColor: 'transparent !important',
  },
  deleteRowIcon: {
    position: 'relative',
    color: theme.palette.buttonBackgroundColor,
    '&:hover': {
      fill: theme.palette.error[500],
    },
  },
  deleteRowIconPosition: {
    position: 'relative',
    top: 82,
    [theme.breakpoints.up('md')]: {
      left: 76,
    },
  },
});

@connect(
  (state) => ({
    addressHashes: getFormValues(CUSTOMER_INFO_FORM)(state).service_addresses || [],
    housecallAddressHashes: getFormValues(CUSTOMER_INFO_FORM)(state).addresses || [],
  }),
  (dispatch) => ({
    onRemoveAddress: (index) => {
      dispatch(onRemoveAddress(index));
    },
  })
)
@ui({
  state: {
    disableFields: (props, state) => props.disableFields || false,
  },
})
@withStyles(styles)
export default class EachAddressContent extends PureComponent {
  UNSAFE_componentWillReceiveProps(newProps) {
    if (newProps.disableFields !== this.props.ui.disableFields) {
      this.props.updateUI('disableFields', newProps.disableFields);
    }
  }

  renderRemoveAddressButton() {
    const { fields, index, classes } = this.props;
    if (!this.props.ui.disableFields && fields.length > 1) {
      return (
        <span className={classes.deleteRowIconPosition}>
          <IconButton
            color="delete"
            className={classes.deleteRowStyle}
            onClick={() => {
              fields.remove(index);
              this.props.onRemoveAddress(index);
            }}
          >
            <CancelIcon className={classes.deleteRowIcon} />
          </IconButton>
        </span>
      );
    }
  }

  getAddress() {
    const { isHousecall, index, addressHashes, housecallAddressHashes } = this.props;

    if (isHousecall) {
      return housecallAddressHashes[index];
    } else {
      return addressHashes[index];
    }
  }

  render() {
    const { index, address } = this.props;
    const { classes } = this.props;

    let addressHash = this.getAddress();
    let latitude = isPresent(addressHash['latitude']) ? addressHash['latitude'] : 0;
    let longitude = isPresent(addressHash['longitude']) ? addressHash['longitude'] : 0;
    const removeAddressRendered = !this.props.ui.disableFields && this.props.fields.length > 1;
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={8}>
          <AddressFormSection
            useLatestMaterialUI={true}
            formName={CUSTOMER_INFO_FORM}
            field={address}
            countryOption={this.props.ui.country}
          />
          <Grid container>
            <Grid item xs={12} style={{ paddingTop: 24 }}>
              <FormTextField
                name={`${address}.notes`}
                label="Address Notes"
                multiline
                disabled={this.props.ui.disableFields}
                fullWidth={true}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid
          item
          xs={removeAddressRendered ? 11 : 12}
          sm={removeAddressRendered ? 5 : 6}
          md={3}
          className={classes.mapPosition}
        >
          <AddressMap index={index} latitude={latitude} longitude={longitude} />
        </Grid>

        <Grid item xs={1} sm={1}>
          {this.renderRemoveAddressButton()}
        </Grid>
      </Grid>
    );
  }
}
